export enum AccountTypeEnum {
  openEnded = '1909',
  closedEnded = '1910',
  NA = '1911',
}
